import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField, Button, RadioGroup, FormControlLabel, Radio, MenuItem } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import HighlightOff from '@material-ui/icons/HighlightOff';
import ArrowUpward from '@material-ui/icons/ArrowDropDownCircleOutlined';
import ArrowDownward from '@material-ui/icons/ArrowDropDownCircleOutlined';
import { timeFormat2, clone, getAge } from '../../../../common/utils';
import { globalData, ADD, EDIT, VIEW, CHILD } from '../../../../common/common';
import EditPanel from './Panel/EditPanel';
import AlertDialog from '../../../Layout/components/AlertDialog';

const Root = styled(Box)({
    width: '100%',
    padding: '0 10px',
    '& .panel-wapper': {
        width: '100%',
        marginTop: '10px',
        padding: '0 10px',
        minHeight: '200px',
        border: '1px dashed #EAE8EB',
        backgroundColor: '#FAFAFA',
        '& .text-wapper': {
            width: '50%',
            paddingRight: '15px',
            '& .text-field': {
                width: '100%',
                // backgroundColor: '#FFFFFF',
            },
        },
        '& .text-title': {
            marginTop: '10px',
            fontSize: '14px',
            color: '#9B9B9B',
        },
        '& .tool-view': {
            width: '100%',
            padding: '10px 0',
        },
    },
    '& .textWapperF': {
        width: '100%',
        paddingRight: '15px',
        '& .textField': {
            width: '100%',
            backgroundColor: '#FFFFFF',
        },
    },
    '& .text-title': {
        marginTop: '10px',
        fontSize: '14px',
        color: '#9B9B9B',
    },
    '& .toolView': {
        width: '100%',
        // borderBottom: '1px dashed #EAE8EB',
        padding: '10px 0',
        '& .delWapper': {
            color: '#C1553A',
            cursor: 'pointer',
            '& .del': {
                width: '15px',
                marginRight: '5px',
            },
        },
        '& .arrowWapper': {
            color: '#009CEE',
            cursor: 'pointer',
            marginRight: '15px',
            '& .arrowUpIcon': {
                width: '15px',
                marginRight: '5px',
                transform: 'rotate(-180deg)',
            },
            '& .arrowIcon': {
                width: '15px',
                marginRight: '5px',
            },
        },
    },
})

class Input2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataInfo: [
                // {
                //     "N.": "",
                //     "DOB": new Date(),
                //     "SEX": "",
                //     "RC": "",
                //     "AddrNPho": {
                //         "phone": "",
                //         "unit": "",
                //         "street": "",
                //         "city": "",
                //         "country": "",
                //         "state": "",
                //         "zipcode": "",
                //     },
                // },
            ],
            stateData: ["CN", "US"],
            btnName: this.btnName(this.props.state),
            openPanel: false,
            panelType: "",
            panelId: "",
            isAdd: false,
            showAlert: false,
            crtId: "",
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
        this.handleArrow = this.handleArrow.bind(this);
        this.handleClosePanel = this.handleClosePanel.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.addInfoData = this.addInfoData.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            dataInfo,
            stateData,
            openPanel,
            panelType,
            panelId,
            isAdd,
            showAlert,
        } = this.state;
        const showArrowBtn = (index) => {
            if (dataInfo.length <= 1) {
                return <div className="arrowWapper h">
                </div>
            }
            if (index === 0) {
                return <div className="h">
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "down")}>
                        <ArrowDownward className="arrowIcon" /><div>MOVE DOWN</div>
                    </div>
                </div>
            } else if (index === dataInfo.length - 1) {
                return <div className="h">
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "up")}>
                        <ArrowUpward className="arrowUpIcon" /><div>MOVE UP</div>
                    </div>
                </div>
            } else {
                return <div className="h">
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "up")}>
                        <ArrowUpward className="arrowUpIcon" /><div>MOVE UP</div>
                    </div>
                    <div className="arrowWapper h" onClick={e => this.handleArrow(e, index, "down")}>
                        <ArrowDownward className="arrowIcon" /><div>MOVE DOWN</div>
                    </div>
                </div>
            }
        }
        const showDelBtn = (index) => {
            if (index !== 0) {
                return <div className="delWapper h" onClick={e => this.handleDelet(e, index)}>
                    <HighlightOff className="del d-e"></HighlightOff> DELETE
                </div>
            } else {
                return <div className="delWapper">
                </div>
            }
        }
        const unitView = (row, index) => {
            if (dataInfo[index]["country"] === "CN") {
                return <div className="text-wapper">
                    <div className="text-title">Child {index + 1} Unit</div>
                    <div>{row["AddrNPho"]["unit"]}</div>
                </div>
            }
        }
        const childView = () => {
            if (dataInfo.length >= 1) {
                return <div>
                    {dataInfo.map((row, index) => (
                        <div className="panel-wapper v" key={index}>
                            <div className="flow">
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Name</div>
                                    <div>{row["N."]}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Date of Birth</div>
                                    <div>{timeFormat2(row["DOB"])}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Gender</div>
                                    <div>{row["SEX"]}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Phone Number (Optional)</div>
                                    <div>{row["AddrNPho"]["phone"]}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Choose The Country</div>
                                    <div>{row["AddrNPho"]["country"]}</div>
                                </div>
                                {unitView(row, index)}
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Street</div>
                                    <div>{row["AddrNPho"]["street"]}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} City</div>
                                    <div>{row["AddrNPho"]["city"]}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} State</div>
                                    <div>{row["AddrNPho"]["state"]}</div>
                                </div>
                                <div className="text-wapper">
                                    <div className="text-title">Child {index + 1} Zip Code</div>
                                    <div>{row["AddrNPho"]["zipcode"]}</div>
                                </div>
                            </div>
                            <div className="tool-view h h-r">
                                <Button size="small" color="primary" onClick={e => this.handleEdit(row)}>Edit</Button>
                            </div>
                            <div className="toolView h h-bt">
                                {showArrowBtn(index)}
                                {showDelBtn(index)}
                            </div>
                        </div>
                    ))}
                </div>
            } else {
                return <div className="panel-wapper c">
                    <div className="c">
                        <Button size="small" color="primary" onClick={this.handleAdd}>Click Add Child Info</Button>
                    </div>
                </div>
            }
        }
        const addBtn = () => {
            if (dataInfo.length >= 1) {
                return <Button disabled={this.isDisabled()} color="primary" onClick={this.handleAdd}>
                    <AddIcon></AddIcon> <b>ADD MORE CHILDREN</b>
                </Button>
            }
        }
        return (
            <Root className="flow">
                {childView()}
                {addBtn()}
                <EditPanel
                    open={openPanel}
                    isAdd={isAdd}
                    data={dataInfo}
                    panelId={panelId}
                    panelType={panelType}
                    onClose={this.handleClosePanel}
                    updateInfoData={this.updateInfoData}
                    addInfoData={this.addInfoData}
                ></EditPanel>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="All related items will be deleted. Are you sure to delete?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    componentDidUpdate(prevProps) {
        const {
            data,
        } = this.props;
        if (prevProps.data !== data) {
            if (data) {
                this.setState({
                    dataInfo: data
                });
            }
        }
    }
    initData() {
        const { data } = this.props;
        if (!data) return;
        // const dataInfo = this.extractData(data);
        this.setState(() => ({
            dataInfo: data
        }))
    }
    extractData(data) {
        if (!data) return [];
        for (const obj of data) {
            let str = obj["AddrNPho"];
            if (!str) return data;
            let strArr = str.split(";");
            if (strArr.length === 7) {
                obj["phone"] = strArr[0];
                obj["unit"] = strArr[1];
                obj["street"] = strArr[2];
                obj["city"] = strArr[3];
                obj["country"] = strArr[4];
                obj["state"] = strArr[5];
                obj["zipcode"] = strArr[6];
                return data;
            } else {
                obj["phone"] = "";
                obj["unit"] = "";
                obj["street"] = "";
                obj["city"] = "";
                obj["country"] = "";
                obj["state"] = "";
                obj["zipcode"] = "";
                return data;
            }
        }
    }
    handleEdit(data) {
        if (data.type === 0) return;
        this.setState({
            panelId: data.id,
            panelType: data.type,
            isAdd: false,
            openPanel: true
        })
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleChange(e, index, name) {
        const value = e.target.value;
        const { dataInfo } = this.state;
        dataInfo[index][name] = value;
        if (name === "phone" || name === "unit"
            || name === "street" || name === "city"
            || name === "country" || name === "state"
            || name === "zipcode") {
            dataInfo[index]["AddrNPho"][name] = value;
        } else if (name === "SEX") {
            if (value === "male") {
                dataInfo[index]["RC"] = "Son";
            } else {
                dataInfo[index]["RC"] = "Daughter";
            }
        } else if (name === "DOB") {
            console.log("xxxxxxxxxxxxx");
            if (getAge(value) < 18) {
                globalData.haveNonage = true;
            } else {
                globalData.haveNonage = false;
            }
        }
        this.setState(() => ({
            dataInfo
        }))
        this.props.setToAllData("Chi", dataInfo);
    }
    handleAdd() {
        this.setState({
            panelType: CHILD,
            isAdd: true,
            openPanel: true
        })
    }
    handleDelet(e, index) {
        const { dataInfo } = this.state;
        const crtId = dataInfo[index].id;
        this.setState({
            crtId,
            showAlert: true
        })
    }
    handleArrow(e, index, type) {
        let dataInfo = clone(this.state.dataInfo);
        let index2 = 0;
        if (type === "up") {
            index2 = index - 1;
        } else if (type === "down") {
            index2 = index + 1;
        }
        [dataInfo[index], dataInfo[index2]] = [dataInfo[index2], dataInfo[index]];
        this.setState(() => ({
            dataInfo
        }))
        this.props.setToAllData("Chi", dataInfo);
    }
    doNext() {
        const { dataInfo } = this.state;
        let canNext = true;
        for (const obj of dataInfo) {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (key === "AddrNPho") {
                        canNext = this.verifyAddrValue(obj[key]);
                        if (canNext) {
                            continue;
                        }
                    } else if (key === ".CHO.Em." || key === "P.W.Pho" || key === "S.W.Pho") {
                        continue;
                    }
                    if (obj[key] === "" || canNext === false) {
                        if (key === "phone") continue;
                        return false;
                    }
                }
            }
        }
        if (dataInfo.length < 1) {
            globalData.toastMsg = "At least 1 child are required";
            return false;
        }
        return true;
    }
    verifyAddrValue(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key === "unit" && obj[key] === "") {
                    if (obj["country"] === "US") {
                        continue;
                    }
                }
                if (key === "phone") {
                    continue;
                }
                if (obj[key] === "") {
                    return false;
                }
            }
        }
        return true;
    }
    getData() {
        return this.state.dataInfo;
    }
    getContentRectData() {
        if (this.props.dragData) {
            return this.addMore.getContentRectData();
        }
        return null;
    }
    handleCollision() {
        this.addMore.handleCollision();
    }
    handleLeave() {
        this.addMore.handleLeave();
    }
    handleUp() {
        this.addMore.handleUp();
    }
    handleDown() {
        this.scrollToBottom();
    }
    scrollToBottom() {
        if (this.messagesEnd) {
            const scrollHeight = this.messagesEnd.scrollHeight;//里面div的实际高度  2000px
            const height = this.messagesEnd.clientHeight;  //网页可见高度  200px
            const maxScrollTop = scrollHeight - height;
            this.messagesEnd.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
            //如果实际高度大于可见高度，说明是有滚动条的，则直接把网页被卷去的高度设置为两个div的高度差，实际效果就是滚动到底部了。
        }
    }
    handleClosePanel() {
        this.setState({
            openPanel: false
        })
    }
    handleAlertYes() {
        this.props.delChildToAllData(this.state.crtId);
        this.setState(() => ({
            showAlert: false
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false
        }));
    }
    updateInfoData(panelData) {
        this.props.uploadChildNormalToAllData(panelData);
    }
    addInfoData(panelData) {
        const { dataInfo } = this.state;
        dataInfo.push(panelData);
        this.setState({
            dataInfo
        }, () => {
            this.props.setToAllData("Chi", dataInfo);
        })
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default Input2;